import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'

import type { ReactElement } from 'react'
import type { MenuPlacement, MenuPosition } from 'react-select'

import BasicCreatableSelectInput from '../../Basic/CreatableSelectInput'

import '../../input-common.scss'

interface Props {
  defaultValue?: IOption
  focus?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  isMulti?: boolean
  label?: string
  menuPortalTarget?: HTMLElement
  menuPosition?: MenuPosition
  name: string
  onChange?: (value: IOption[] | IOption) => void
  options?: IOption[]
  placeholder?: string
  placement?: MenuPlacement
  required?: boolean
}

const CreatableSelectInput = ({
  defaultValue,
  focus,
  isDisabled,
  isLoading = false,
  isMulti = false,
  label,
  menuPortalTarget,
  menuPosition,
  name,
  onChange,
  options,
  placeholder,
  placement,
  required,
}: Props): ReactElement => {
  const [field, { error, touched }, { setValue }] = useField<IOption[] | IOption>(name)

  const handleChange = (selectedOption: IOption[] | IOption) => {
    setValue(selectedOption)
    onChange && onChange(selectedOption)
  }

  return (
    <div className="input-component select-input-component input-container">
      <div className={classNames('field-container', { erroneous: touched && error })}>
        <BasicCreatableSelectInput
          {...field}
          autoFocus={focus}
          className={classNames({ erroneous: touched && error })}
          closeMenuOnSelect={!isMulti}
          defaultValue={defaultValue}
          disabled={isDisabled}
          isLoading={isLoading}
          isMulti={isMulti}
          label={label}
          menuPlacement={placement}
          menuPortalTarget={menuPortalTarget}
          menuPosition={menuPosition}
          onChange={(value: unknown) => handleChange(value as IOption[] | IOption)}
          options={options}
          placeholder={placeholder}
          required={required}
        />
      </div>
      {touched && error ? <ErrorMessage className="error-message" component="span" name={name} /> : null}
    </div>
  )
}

export default CreatableSelectInput
